export default __webpack_public_path__ + "static/triggers-en-fbc43750f6a6db9769361eec8aae4fde.png";